// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__2Ll-Y","header":"ReportDetails_header__RNkR4","title":"ReportDetails_title__3lsBl","left":"ReportDetails_left__uQjN0"};